import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="flex items-center justify-center"
    >
      <path d="M11.54 10.46 8 6.92l-3.54 3.54-.92-.92L8 5.08l4.46 4.46z" />
    </svg>
  )
}
const ChevronUp = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
ChevronUp.defaultProps = {
  width: 16,
  height: 16,
  fill: 'rgba(0,0,0,0.40)',
}
// 参数类型
ChevronUp.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default ChevronUp
